/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Yellow': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="none" fill-rule="evenodd"><rect pid="0" _fill="#F2AA52" width="32" height="32" rx="16"/><text font-family="Lato-Bold, Lato" font-size="14" font-weight="bold" _fill="#566473"></text></g>'
  }
})
